import KeyMirror from 'keymirror'

export const ACTIVITY_CATEGORIES = KeyMirror({
  ALL: null,
  APPT_AND_FU: null,
  REFERRALS_AND_MEDICAL_NOTES: null,
  PRESCRIPTIONS_AND_LABS: null,
  PAYMENTS_AND_FUNDS: null,
})
